import type { EdgeRuntimeSnapshot } from "@sitescene/types";
export function applicationStatus(
	desired: null | string,
	report: EdgeRuntimeSnapshot["report"],
) {
	if (!desired) return "No published configuration";
	if (report.attemptedRevision === desired) {
		if (report.state === "applying") return "Applying published configuration";
		if (report.state === "rejected") return "Published configuration rejected";
		if (report.state === "retrying") return "Device reports retry pending";
		if (report.state === "recovery_pending")
			return "Device reports recovery pending";
	}
	if (report.appliedRevision === desired && report.state === "applied")
		return "Published configuration applied";
	return "Waiting for the Edge Device to apply the published configuration";
}
export function timestamp(value?: Date | null | string) {
	if (!value) return "Not reported";
	if (typeof value === "string" && !/(?:Z|[+-]\d{2}:\d{2})$/.test(value))
		return "Unknown time";
	const date = new Date(value);
	return Number.isFinite(date.getTime())
		? date.toLocaleString(undefined, { timeZoneName: "short" })
		: "Unknown time";
}
